export default [
  {
    title: 'breadcrumb.abaCallback',
    route: 'aba-callback',
    icon: 'DollarSignIcon',
    resource: 'aba-callback',
    action: 'read',
  },
]
